import React, { useState } from 'react';
import { packAndTrack } from '@v2/services/analytics.service';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { emailRegex } from '@components/common/helpers/regex';
import { buildRequest, RequestMethod, apiRequest } from '@utils/http';
import styles from '@v2/components/pages/shop/shop.styles';

export default function UpcomingTab() {
    const [email, setEmail] = useState(null);
    const [completed, setCompleted] = useState(false);
    const [processing, setProcessing] = useState(false);
    const { register, handleSubmit, formState: {errors} } = useForm({ reValidateMode: 'onBlur' });

    async function emailSubmit() {
        setProcessing(true);

        packAndTrack('Subscribed to Coming soon', [{
            view: 'Product Page',
            section: 'Products',
            email: email
        }]);

        const request = buildRequest(RequestMethod.PUT, true, { 'email': email, 'comingSoon': true });
        const response = await apiRequest('@v2/mailing', request);

        if (response.status === 200) {
            // do nothing for now, we only record emails in our db just in case...
        }

        setProcessing(false);
        setCompleted(true);
    }

    return (
        <div className={`category ${styles.upcomingBanner}`} id="upcoming">
            <div className="header">
                <div className="info">
                    <div className="row">
                        <div className="col-md-7 col-12">
                            <div className="info-text">
                                <h4>
                                    coming soon
                                </h4>
                                <h3>
                                    Be the first to know when we drop delicious new products!
                                </h3>
                                {!completed
                                    ?
                                    <>
                                        <form onSubmit={handleSubmit(emailSubmit)} className="upcoming-form">
                                            <input
                                                type="email"
                                                name="email"
                                                aria-label={'email'}
                                                placeholder="Email address"
                                                className={errors.email ? 'error' : ''}
                                                value={email || ''}
                                                disabled={processing}
                                                {...register('email', {
                                                    onChange: (e: any) => setEmail((e.target as HTMLInputElement).value),
                                                    required: 'This field is required',
                                                    pattern: {
                                                        value: emailRegex,
                                                        message: 'Please provide a valid email address',
                                                    }
                                                })} />
                                            <button className="button primary blue" type="submit" disabled={processing} >notify me</button>
                                            <>
                                                {errors.email &&
                                                    <div className="error-message"><ErrorMessage errors={errors} name="email" /></div>
                                                }
                                            </>
                                        </form>
                                    </>
                                    :
                                    <div className="confirmation-message">Thank you for subscribing!</div>
                                }
                            </div>
                        </div>
                        <div className="info-image col-md-5 col-12">
                            <div className="image"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
